import { TrackingEvent } from '@owc/connection-aem-tracking';
import globalMeta from '../../../../package.json';
interface ApplicationParams {
  id: string;
  version: string;
  parentApplicationId: string | undefined;
}
class TrackingService {
  private readonly applicationParams: ApplicationParams;
  private trackingDispatcher: any;
  public constructor(applicationParams: ApplicationParams) {
    this.applicationParams = { ...applicationParams };
  }

  public track = (eventToTrack: any) => {
    if ((process.env.NODE_ENV as string) !== 'production') {
      console.log('tracked', { ...eventToTrack, application: this.applicationParams } as TrackingEvent);
    }
    this.trackingDispatcher &&
      this.trackingDispatcher.pushTrackingEvent({
        ...eventToTrack,
        application: this.applicationParams,
      } as TrackingEvent);
  };

  public initializeTrackingDispatcher = (dispatcher: any) => {
    this.trackingDispatcher = dispatcher;
  };
}

enum SubContextMapper {
  aem = 'aem',
}

export const trackingService = new TrackingService({
  id: 'vmos',
  version: globalMeta.version,
  parentApplicationId: SubContextMapper.aem,
});
